import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from './AdFormEmailPassword.module.css'
import { NextButton } from '../../../Common/CtaButton/NextButton'
import { BackButton } from '../../../Common/CtaButton/BackButton'
import { FormField } from '../../../../Common/FormField'
import { StepContext } from '../../StepContainer'
import { useAbTestGtm } from '../../../../../hooks/useAbTestGtm'
import { validateForm } from './validate'

export const AdFormEmailPassword = () => {
    const { formState } = useContext(StepContext)
    const { dataViewLabel, dataClickLabel } = useAbTestGtm()

    const prefillEmail = formState.email || ''
    const isEmailDisabled = useRef(!!prefillEmail).current

    const [email, setEmail] = useState(prefillEmail)
    const [password, setPassword] = useState('')
    const [isFormValid, setIsFormValid] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [errors, setErrors] = useState({
        email: '',
        password: '',
    })
    const [touched, setTouched] = useState({
        email: isEmailDisabled, // pre-fill 済みなら touched 扱い
        password: false,
    })

    useEffect(() => {
        const validateAndSetState = async () => {
            const { errors: validationErrors, isValid } = await validateForm(
                email,
                password,
                touched,
                isEmailDisabled
            )
            setErrors(validationErrors)
            setIsFormValid(isValid)
        }

        validateAndSetState()
    }, [email, password, touched, isEmailDisabled])

    const handleBlur = (field: string) => {
        setTouched(prev => ({
            ...prev,
            [field]: true,
        }))
    }

    return (
        <div
            className={styles.wrapper}
            data-view-label={dataViewLabel('EF_StepForm_メールアドレス')}
        >
            <div className={styles.backHeaderRow}>
                <BackButton
                    dataClickLabel={dataClickLabel(
                        'EF_StepForm_メールアドレス-戻る'
                    )}
                />
                <p className={styles.stepTitle}>
                    最後に、ログイン用の
                    <br />
                    パスワードを設定しましょう
                </p>
            </div>
            <div className={styles.selectionWrapper}>
                {/* メールアドレス */}
                <div className={styles.mailField}>
                    <>
                        <FormField
                            label="メールアドレス"
                            placeholder="メールアドレスを入力(ログインID)"
                            value={email}
                            onBlur={() => handleBlur('email')}
                            onChange={setEmail}
                            disabled={isEmailDisabled}
                        />
                        {errors.email && (
                            <p className={styles.errorMessages}>
                                {errors.email}
                            </p>
                        )}
                    </>
                </div>

                {/* パスワード */}
                <div className={styles.passField}>
                    <FormField
                        label="パスワード"
                        placeholder="パスワード：大小英数字含む8文字以上"
                        value={password}
                        onChange={setPassword}
                        onBlur={() => handleBlur('password')}
                        isInputType={showPassword ? 'text' : 'password'}
                    />
                    <label className={styles.customCheckbox}>
                        パスワードを表示
                        <input
                            type="checkbox"
                            onChange={e => setShowPassword(e.target.checked)}
                        />
                        <span className={styles.checkMark}></span>
                    </label>
                    {errors.password && (
                        <p className={styles.errorMessages}>{errors.password}</p>
                    )}
                    <div className={styles.validationHintWrap}>
                        <img
                            src="/foodslaboEf/img/step8/lightIcon.svg"
                            alt="電球アイコン"
                        />
                        <p className={styles.validationHint}>
                            パスワードは最低8文字以上です。大小英数字は含まれていますか？
                        </p>
                    </div>
                </div>

                <div className={styles.nextButtonWrapper}>
                    <NextButton
                        formKey={['email', 'password']}
                        formValue={[email, password]}
                        displayFormKey={['email', 'password']}
                        displayFormValue={[email, password]}
                        isDisabled={!isFormValid}
                        confirmation="確認画面へ"
                        dataClickLabel={dataClickLabel(
                            'EF_StepForm_メールアドレス-次へ'
                        )}
                    />
                </div>
            </div>
        </div>
    )
}
